import { Component, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { OperationStatusService } from '../../../core/services/operation/operation-status/operation-status.service'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import { PagedContactTypeResponse } from '../../../core/models/contact-type.model'
import { IndividualClientService } from '../../../core/services/customer/individual-client/individual-client.service'
import { SubClientService } from '../../../core/services/customer/sub-client/sub-client.service'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../shared/utils/utils'
import { SubClientEditComponent } from '../../../features/customer/sub-client/sub-client-edit/sub-client-edit.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import { ModalDeleteClientComponent } from '../../../features/customer/modal-delete-client/modal-delete-client.component'
import { ClientConvertSubClientComponent } from '../../../features/customer/client-convert-subclient/client-convert-subclient.component'
import { SubclientConvertClientComponent } from '../../../features/customer/subclient-convert-client/subclient-convert-client.component'

@Component({
  selector: 'sub-client',
  imports: [
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    FormClientSearchComponent,
    MatPaginatorModule,
  ],
  templateUrl: './sub-client.component.html',
  styleUrl: './sub-client.component.scss',
  standalone: true,
  providers: [OperationStatusService, IndividualClientService, AuthService],
})
export class SubClientComponent implements OnInit {
  constructor(
    private subClientService: SubClientService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  columns: any[] = [
    {
      keyColumn: 'name',
      key: 'nomeFantasia',
      description: 'Nome Fantasía',
    },
    {
      keyColumn: 'corporate_name',
      key: 'razaoSocial',
      description: 'Razão social',
    },
    {
      keyColumn: 'cnpj',
      key: 'cnpj',
      description: 'CNPJ/CPF',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]

  listSearch: any = [
    { id: 'nome', description: 'Nome', type: 'string', visible: true },
    // { id: 'cpf', description: 'CPF', type: 'string', visible: true },
    {
      id: 'razaoSocial',
      description: 'Razão Social',
      type: 'string',
      visible: true,
    },
    { id: 'cnpj', description: 'Cnpj/Cpf', type: 'string', visible: true },
    {
      id: 'inscMunicipal',
      description: 'Inscrição Municipal',
      type: 'string',
      visible: false,
    },
    {
      id: 'inscEstadual',
      description: 'Inscrição Estadual',
      type: 'string',
      visible: false,
    },
  ]

  inputSearch: any = { type: '', search: '' }
  searchForm: any = { search: false, model: {} }

  screen: string = 'subcliente'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('remover'),
        convertSubClient: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  // search(event: any) {
  //   let search = event
  //   this.page = 1
  //   if (search) {
  //     this.searchForm.descricao = search
  //     this.searchListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    let model: any = {}
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.subClientService.listPagedSubClient(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => {},
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.subClientService
      .searchPagedSubClient(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(SubClientEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
    const dialogRef = this.dialog.open(ModalDeleteClientComponent, {
      maxWidth: '40vw',
      width: '100%',
      maxHeight: '90vh',
      data: { item: item, typeClient: 'subClient' },
    })
    dialogRef.componentInstance.responseDelete.subscribe((response) => {
      if (response.delete) {
        this.uploadList()
      }
    })
  }

  convertClientItem(item: any) {
    const dialogRef = this.dialog.open(SubclientConvertClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '90vw',
      width: '100%',
      maxHeight: '90vh',
      data: { type: 'legal-entity-client', item: item },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }
}
